export default {
  PRODUCT_SHELVES_TIME_FORMAT: 'DDd HH:mm:ss'
};
